[
    {
        "policyId": 1026710523,
        "uqPolicyId": 1068422824,
        "policyNumber": "7050002306",
        "productName": "CASCOG - CASCO - skupinov\u00e9 poistenie",
        "statusId": 4,
        "status": "akt\u00edvna",
        "productNameSpecific": "PS01",
        "paidToDate": "2021-05-04T00:00:00.000+02:00",
        "leasFleetFlag": false,
        "packageId": 3004,
        "greenBoxPolicy": false,
        "lineOfBusiness": "CA - Havarijn\u00e9 poistenie",
        "paymentFrequency": "mesa\u010dne",
        "paymentMethod": "skupinov\u00e1 platba",
        "type": "dlhodob\u00e1 na dobu neur\u010dit\u00fa",
        "lineOfBusinessId": 3,
        "beginDate": "2014-01-01T00:00:00.000+01:00",
        "endDate": null,
        "paymentMethodId": 10,
        "paymentFrequencyId": 5,
        "effectiveFromDate": "2025-04-01T00:00:00.000+02:00",
        "effectiveEndDate": null,
        "typeId": 2,
        "premiumAmount": 455.52,
        "premiumCurrency": "EUR",
        "premiumMaturityDate": "2021-07-29T00:00:00.000+02:00",
        "premiumStatus": "overdue",
        "annualPremium": null,
        "termPremium": null,
        "detailTypeIdentifier": "CAR-INSURANCE",
        "crn": null,
        "model": null,
        "dateBeginOrig": null,
        "paymentBlockageFlag": false,
        "annualPaidPremium": null,
        "bankAccount": [
            {
                "account": "SK7011000000002625002865",
                "policyHolderInDescr": 0,
                "policyHolderAccount": 1,
                "bankDescript": "VOLKSWAGEN Finan\u010dn\u00e9 slu\u017eby,"
            }
        ],
        "firstInsuredName": null,
        "gatewayPaymentUrl": "https:\/\/online.allianz.sk\/platobna-brana\/ZTAyYTBmZDE0ZDI0Y2I0Y2Y1Mzc3NzVlNDc0MzgwZjlfNzA1MDAwMjMwNl80NTUuNTJfM19fQ1BfZWtwdGVzdDIyMEBhbGxpYW56LnNr",
        "isElectricVehicle": false
    },
    {
        "policyId": 1026710357,
        "uqPolicyId": 1068418818,
        "policyNumber": "7050002266",
        "productName": "CASCOG - CASCO - skupinov\u00e9 poistenie",
        "statusId": 4,
        "status": "akt\u00edvna",
        "productNameSpecific": "PS01",
        "paidToDate": "2024-06-22T00:00:00.000+02:00",
        "leasFleetFlag": false,
        "packageId": 3004,
        "greenBoxPolicy": false,
        "lineOfBusiness": "CA - Havarijn\u00e9 poistenie",
        "paymentFrequency": "mesa\u010dne",
        "paymentMethod": "skupinov\u00e1 platba",
        "type": "dlhodob\u00e1 na dobu neur\u010dit\u00fa",
        "lineOfBusinessId": 3,
        "beginDate": "2014-01-01T00:00:00.000+01:00",
        "endDate": null,
        "paymentMethodId": 10,
        "paymentFrequencyId": 5,
        "effectiveFromDate": "2025-04-01T00:00:00.000+02:00",
        "effectiveEndDate": null,
        "typeId": 2,
        "premiumAmount": 1031.12,
        "premiumCurrency": "EUR",
        "premiumMaturityDate": "2024-06-19T00:00:00.000+02:00",
        "premiumStatus": "overdue",
        "annualPremium": null,
        "termPremium": null,
        "detailTypeIdentifier": "CAR-INSURANCE",
        "crn": null,
        "model": null,
        "dateBeginOrig": null,
        "paymentBlockageFlag": false,
        "annualPaidPremium": null,
        "bankAccount": [
            {
                "account": "SK7011000000002625002865",
                "policyHolderInDescr": 0,
                "policyHolderAccount": 1,
                "bankDescript": "VOLKSWAGEN Finan\u010dn\u00e9 slu\u017eby,"
            }
        ],
        "firstInsuredName": null,
        "gatewayPaymentUrl": "https:\/\/online.allianz.sk\/platobna-brana\/NzJlNjU3NmE5ZjZlZjNkYTAyODU0ODRiZGFkZGIxNmFfNzA1MDAwMjI2Nl8xMDMxLjEyXzNfX0NQX2VrcHRlc3QyMjBAYWxsaWFuei5zaw%3D%3D",
        "isElectricVehicle": false
    },
    {
        "policyId": 1026710465,
        "uqPolicyId": 1068424064,
        "policyNumber": "7950000004",
        "productName": "A06 - Poistenie finan\u010dnej straty - GAP2",
        "statusId": 4,
        "status": "akt\u00edvna",
        "productNameSpecific": "Havarijn\u00e9 poistenie",
        "paidToDate": "2019-06-14T00:00:00.000+02:00",
        "leasFleetFlag": false,
        "packageId": 3008,
        "greenBoxPolicy": false,
        "lineOfBusiness": "CA - Havarijn\u00e9 poistenie",
        "paymentFrequency": "mesa\u010dne",
        "paymentMethod": "skupinov\u00e1 platba",
        "type": "dlhodob\u00e1 na dobu neur\u010dit\u00fa",
        "lineOfBusinessId": 3,
        "beginDate": "2014-01-01T00:00:00.000+01:00",
        "endDate": null,
        "paymentMethodId": 10,
        "paymentFrequencyId": 5,
        "effectiveFromDate": "2025-04-01T00:00:00.000+02:00",
        "effectiveEndDate": null,
        "typeId": 2,
        "premiumAmount": 223.9,
        "premiumCurrency": "EUR",
        "premiumMaturityDate": "2019-06-30T00:00:00.000+02:00",
        "premiumStatus": "overdue",
        "annualPremium": 0,
        "termPremium": 0,
        "detailTypeIdentifier": "CAR-INSURANCE",
        "crn": null,
        "model": null,
        "dateBeginOrig": null,
        "paymentBlockageFlag": false,
        "annualPaidPremium": 0,
        "bankAccount": [
            {
                "account": "SK7011000000002625002865",
                "policyHolderInDescr": 0,
                "policyHolderAccount": 1,
                "bankDescript": "VOLKSWAGEN Finan\u010dn\u00e9 slu\u017eby,"
            }
        ],
        "firstInsuredName": null,
        "gatewayPaymentUrl": "https:\/\/online.allianz.sk\/platobna-brana\/MTA5ZjA3YjQ2MWY2MjU2NzdiNTRjNzU4NjgwODg0ZDNfNzk1MDAwMDAwNF8yMjMuOV8zX19DUF9la3B0ZXN0MjIwQGFsbGlhbnouc2s%3D",
        "isElectricVehicle": false
    },
    {
        "policyId": 1028121517,
        "uqPolicyId": 1064955926,
        "policyNumber": "8050004052",
        "productName": "MTPL - Motor Third Part Liability Standard",
        "statusId": 4,
        "status": "akt\u00edvna",
        "productNameSpecific": "Povinn\u00e9 zmluvn\u00e9 poistenie",
        "paidToDate": "2025-06-24T00:00:00.000+02:00",
        "leasFleetFlag": false,
        "packageId": 4002,
        "greenBoxPolicy": false,
        "lineOfBusiness": "MT - Povinn\u00e9 zmluvn\u00e9 poistenie",
        "paymentFrequency": "mesa\u010dne",
        "paymentMethod": "skupinov\u00e1 platba",
        "type": "dlhodob\u00e1 na dobu neur\u010dit\u00fa",
        "lineOfBusinessId": 8,
        "beginDate": "2014-06-01T00:00:00.000+02:00",
        "endDate": null,
        "paymentMethodId": 10,
        "paymentFrequencyId": 5,
        "effectiveFromDate": "2024-04-25T00:00:00.000+02:00",
        "effectiveEndDate": null,
        "typeId": 2,
        "premiumAmount": 45177.79,
        "premiumCurrency": "EUR",
        "premiumMaturityDate": "2025-01-21T00:00:00.000+01:00",
        "premiumStatus": "paid",
        "annualPremium": 0,
        "termPremium": 0,
        "detailTypeIdentifier": "CAR-INSURANCE",
        "crn": null,
        "model": null,
        "dateBeginOrig": null,
        "paymentBlockageFlag": false,
        "annualPaidPremium": 0,
        "bankAccount": [
            {
                "account": "SK7011000000002625002865",
                "policyHolderInDescr": 0,
                "policyHolderAccount": 1,
                "bankDescript": "VOLKSWAGEN Finan\u010dn\u00e9 slu\u017eby,"
            }
        ],
        "firstInsuredName": null,
        "gatewayPaymentUrl": "https:\/\/online.allianz.sk\/platobna-brana\/NTJlZGNlODAxZjc5OWU2OGEzMmQ3MWExOWI4NWZkYzNfODA1MDAwNDA1Ml80NTE3Ny43OV84X19DUF9la3B0ZXN0MjIwQGFsbGlhbnouc2s%3D",
        "isElectricVehicle": false
    }
]